module.exports = __webpack_public_path__ + "img/facebook.2dca8cfe.svg";